import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getCredits(perPage, page) {
        return Axios.get(`${baseURL}billing/credits`, {
            params: { per_page: perPage, page: page }
        }).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    createCredit(data) {
        return Axios.post(`${baseURL}billing/credit`, data).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    },
    updateCredit(data, creditId) {
        return Axios.put(`${baseURL}billing/credit/${creditId}`, data).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                } else {
                    return null;
                }
            }
        );
    },
    removeCredit(creditId) {
        return Axios.delete(`${baseURL}billing/credit/${creditId}`).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                } else {
                    return null;
                }
            }
        );
    },
    convertToRefund(data) {
        return Axios.post(
            `${baseURL}billing/credit/convert-refund/${data.id}`,
            data
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    },
    convertToCharitableFund(data) {
        return Axios.post(
            `${baseURL}billing/credit/convert-to-fund/${data.id}`,
            data
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    },
    getRefundType(data) {
        return Axios.get(`${baseURL}billing/refund-type`, data).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    },
    refundToCard(data) {
        return Axios.post(`${baseURL}billing/credit/refund-to-card`, data).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                } else {
                    return null;
                }
            }
        );
    },
    getUsedStatus(creditId) {
        return Axios.get(
            `${baseURL}billing/credit/check-used-status/${creditId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    }
};
